export default {"src":"https://roboneo-static.meitudata.com/public/release/_next/static/media/favicon.067de052.ico","height":32,"width":32};